
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ho-tro",
      function () {
        return require("private-next-pages/ho-tro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ho-tro"])
      });
    }
  